module.exports = __webpack_public_path__ + "static/v20-a206699838097a7c1b0d4dd770c7599a.jpg";